import { BaseModel } from "../../Bases/BaseModel";



export class UsuarioPainel extends BaseModel {
  constructor(
    public usuario_id = 0,
    public nome_painel = '',
    public url_painel = ''

  ) {
    super();
  }
}
